// ets_tracing: off
import { flow } from "@effect-ts/core/Function";
import { runEither } from "@effect-ts/core/Sync";
import { summonFor } from "../Batteries/summoner/index.mjs";
import { modelDecoderInterpreter } from "./interpreter/index.mjs";
export { decoderExtension } from "./interpreter/index.mjs";
export { DecoderType, DecoderURI, decoderApplyConfig } from "./base/index.mjs";
export { appendContext, fail, failures, makeDecoder } from "./common/index.mjs";
export { report, formatValidationErrors, formatValidationError, TYPE_MAX_LEN } from "./reporters/index.mjs";
export function deriveFor(S) {
  return _ => F => F.derive(modelDecoderInterpreter())(_);
}
const decoders = /*#__PURE__*/new Map();
const defDerive = /*#__PURE__*/deriveFor(summonFor({}).make)({});
export function decoder(F) {
  if (decoders.has(F)) {
    return decoders.get(F).decoder;
  }

  const d = defDerive(F);
  decoders.set(F, d);
  return d.decoder;
}
export function decoderType(F) {
  if (decoders.has(F)) {
    return decoders.get(F);
  }

  const d = defDerive(F);
  decoders.set(F, d);
  return d;
}
export function runDecode(F) {
  return flow(decoder(F).decode, runEither);
}
export function decode(F) {
  return decoder(F).decode;
}
//# sourceMappingURL=index.mjs.map